/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.f122n59{align-items:center;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1w5jphr{min-height:40px;}
.f1nxs5xn{min-height:32px;}
.f778t4r{row-gap:var(--spacingVerticalXS);}
.fqerorx{flex-grow:1;}
/** @griffel:css-end **/